webpackJsonp([76758144387212],{

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/arrow.64c74fc0.png";

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Fade = __webpack_require__(27);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _colors = __webpack_require__(8);
	
	__webpack_require__(43);
	
	__webpack_require__(44);
	
	__webpack_require__(21);
	
	var _SectionContainer = __webpack_require__(33);
	
	var _SectionContainer2 = _interopRequireDefault(_SectionContainer);
	
	var _SectionContainerBackground = __webpack_require__(34);
	
	var _SectionContainerBackground2 = _interopRequireDefault(_SectionContainerBackground);
	
	var _SectionHeaderContent = __webpack_require__(47);
	
	var _SectionHeaderContent2 = _interopRequireDefault(_SectionHeaderContent);
	
	var _SectionContent = __webpack_require__(35);
	
	var _SectionContent2 = _interopRequireDefault(_SectionContent);
	
	var _Button = __webpack_require__(16);
	
	var _SectionImages = __webpack_require__(37);
	
	var _SectionImages2 = _interopRequireDefault(_SectionImages);
	
	var _SectionImage = __webpack_require__(36);
	
	var _SectionImage2 = _interopRequireDefault(_SectionImage);
	
	var _FAQHeader = __webpack_require__(46);
	
	var _FAQHeader2 = _interopRequireDefault(_FAQHeader);
	
	var _arrow = __webpack_require__(576);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _withScreensize = __webpack_require__(38);
	
	var _withScreensize2 = _interopRequireDefault(_withScreensize);
	
	var _ScreensizeProvider = __webpack_require__(30);
	
	var _ScreensizeProvider2 = _interopRequireDefault(_ScreensizeProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pageData = {
	  FAQHeadline: "Check out our Demo Store!",
	  FAQCopy: "We set this up to help you get a better idea to idea of what your store can look like!",
	  FAQLink: "https://my.tinymerch.com",
	  FAQwhatIsCTA: "Get Started!"
	};
	
	var DemoPrompt = _styledComponents2.default.div.withConfig({
	  displayName: "demo__DemoPrompt"
	})(["display:flex;width:60%;img{position:absolute;bottom:100px;right:100px;width:300px;}@media screen and (max-width:768px){img{display:none;}}"]);
	
	var _Demo = function (_Component) {
	  _inherits(_Demo, _Component);
	
	  function _Demo() {
	    _classCallCheck(this, _Demo);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  _Demo.prototype.componentDidMount = function componentDidMount() {
	    document.body.className = "Demo";
	  };
	
	  _Demo.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.body.className = "";
	  };
	
	  _Demo.prototype.render = function render() {
	    var props = this.props;
	
	    var isMobile = props.screensize === "phones";
	    var isTablet = props.screensize === "thatUglyInBetweenSize";
	    var isSmall = props.screensize === "devWithConsoleOpen";
	    var isWidescreen = props.screensize === "widescreenFools";
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: "TinyMerch |\xA0FAQ \u2013 What is TinyMerch" }),
	      _react2.default.createElement(
	        _SectionContainer2.default,
	        { justify: "flex-start", align: "flex-start" },
	        _react2.default.createElement(
	          _SectionContent2.default,
	          {
	            justify: isMobile ? "flex-start" : isTablet ? "flex-start" : "center",
	            align: "flex-start",
	            color: true,
	            height: "90vh",
	            width: isMobile ? "95%" : isTablet ? "80%" : isWidescreen ? "40%" : "50%"
	          },
	          _react2.default.createElement(
	            "h3",
	            { style: { fontWeight: "400" } },
	            "\uD83D\uDC4B Hi everyone,"
	          ),
	          _react2.default.createElement(
	            "h1",
	            null,
	            pageData.FAQHeadline
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            pageData.FAQCopy
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "It's also here to sell cool TinyMerch merch! \uD83D\uDE1C"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: pageData.FAQLink },
	            _react2.default.createElement(
	              _Button.TinyButton,
	              null,
	              pageData.FAQwhatIsCTA
	            )
	          )
	        ),
	        _react2.default.createElement(
	          DemoPrompt,
	          null,
	          _react2.default.createElement("img", { src: _arrow2.default })
	        )
	      )
	    );
	  };
	
	  return _Demo;
	}(_react.Component);
	
	var Demo = (0, _withScreensize2.default)(_Demo);
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _ScreensizeProvider2.default,
	    null,
	    _react2.default.createElement(Demo, props)
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-demo-js-9d511362830a2dcf71e3.js